import { headVersionName } from "@buildwithflux/models";
/**
 * @deprecated Call constructor of FirestorePartVersionRepository directly
 * @param db
 */
export const createFirestorePartVersionRepository = (db) => {
    return new FirestorePartVersionRepository(db);
};
export class FirestorePartVersionRepository {
    db;
    constructor(db) {
        this.db = db;
    }
    // QUESTION: shouldn't the return type be Promise<IPartVersionData | undefined>?
    async get(partUid, partVersion) {
        return this.db
            .partVersion(partUid, partVersion)
            .get()
            .then((doc) => doc.data());
    }
    async getAll(partUid) {
        return this.db
            .partVersionCollection(partUid)
            .get()
            .then((result) => {
            return result.docs.map((doc) => doc.data());
        });
    }
    async save(partVersion) {
        await this.db.partVersion(partVersion.part_uid, partVersion.version).set(partVersion);
    }
    async merge(partUid, partVersionName, updatedFields) {
        if (partVersionName !== headVersionName) {
            // Any part version other than HEAD is immutable
            throw new Error(`Trying to mutate a part version thats NOT HEAD, partUid: ${partUid}, version ${partVersionName}.`);
        }
        // NOTE: Calling `.set` with {merge: true} here so that we only update the passed in fields,
        // and can trigger the converter for partVersionData, which is important to make schema consistent
        await this.db.partVersion(partUid, partVersionName).set(updatedFields, { merge: true });
    }
    async update(partUid, partVersionName, updatedFields) {
        if (partVersionName !== headVersionName) {
            // Any part version other than HEAD is immutable
            throw new Error(`Trying to mutate a part version thats NOT HEAD, partUid: ${partUid}, version ${partVersionName}.`);
        }
        await this.db.partVersion(partUid, headVersionName).update(updatedFields);
    }
    async destroy(partUid, partVersion) {
        await this.db.partVersion(partUid, partVersion).delete();
    }
    /**
     * Subscribe to changes on a specific part version.
     */
    subscribeToPartVersionChanges(partUid, partVersion, onChange) {
        return this.db.partVersion(partUid, partVersion).onSnapshot((partSnapshot) => {
            if (partSnapshot.exists) {
                onChange(partSnapshot.data());
            }
        });
    }
}
//# sourceMappingURL=FirestorePartVersionRepository.js.map